import { ChatTurnResult, SendMessageRes } from "../type/chat";
import { parseHitlInterrupt, parseAsyncJobInterrupt, parseTurnDisplay } from "./rag-response";
import {
  RagRunCompletedEvent,
  RagRunRequiresActionEvent,
  RagRunErrorEvent,
} from "../type/rag-stream-event";

export function turnResultFromRunCompleted(event: RagRunCompletedEvent): ChatTurnResult {
  const res = event.response;
  return {
    chatId: event.chat_id,
    chatNo: event.chat_no,
    output: res.output || "",
    figure: res.figure,
    used_tools: res.used_tools,
    newModelId: res.next_model_id,
    queriedModelId: res.queried_model_id,
    artifactUrls: res.artifact_urls,
    interrupt: parseHitlInterrupt(event.interrupt),
    asyncJob: parseAsyncJobInterrupt(event.async_job),
    runId: event.run_id,
    turnDisplay: parseTurnDisplay(res.turn_display),
  };
}

export function turnResultFromRequiresAction(event: RagRunRequiresActionEvent): ChatTurnResult {
  const interrupt = parseHitlInterrupt({
    thread_id: event.action.thread_id,
    prompt: event.action.prompt,
    tool_calls: event.action.tool_calls,
  });
  if (!interrupt) {
    throw new Error("Invalid HITL requires_action payload");
  }
  return {
    chatId: event.chat_id,
    chatNo: event.chat_no,
    output: "",
    interrupt,
    runId: event.run_id,
  };
}

export function ragResponseFromRunCompleted(event: RagRunCompletedEvent): SendMessageRes {
  const res = event.response;
  return {
    chat_id: event.chat_id,
    chat_no: event.chat_no,
    tool_execution_role: event.tool_execution_role ?? undefined,
    response: {
      output: res.output || "",
      figure: res.figure,
      used_tools: res.used_tools,
      queried_model_id: res.queried_model_id,
      next_model_id: res.next_model_id,
      artifact_urls: res.artifact_urls,
      turn_display: res.turn_display,
    },
    interrupt: parseHitlInterrupt(event.interrupt) ?? null,
  };
}

export function errorMessageFromRunError(event: RagRunErrorEvent): string {
  return event.message || "An error occurred while processing your request.";
}
